<template>
  <ClientOnly>
    <FsLightbox
      :toggler="toggler"
      :slide="slide"
      :sources="computedImages"
      :thumbs="computedThumbnails"
      type="image"
      show-thumbs-on-mount
      :on-slide-change="changeSlide"
      :on-open="openSlide"
      :on-close="emit('close')"
      disable-local-storage
      @vue:mounted="emit('mounted')"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import FsLightbox from '~/vendor/fslightbox-vue/v3'
import type { Nullable } from '~/types'
import type { SwipeContent } from '~/components/_tailwind/swipe/types'
import { AppVideoPlayer } from '#components'

const props = defineProps<{
  images: SwipeContent[]
  index?: number
}>()

const emit = defineEmits<{
  'track-image': [instance: number]
  'mounted': []
  'close': []
}>()

const { getDynamicImage, presets } = useImage()

// When the index of the image changes from outside, show the lightbox.
watch(
  () => props.index,
  (newIndex, oldIndex) => {
    if (typeof newIndex === 'number' && newIndex !== oldIndex) {
      showLightBox(newIndex)
    }
  },
)

const toggler = ref(false)
const slide: Ref<Nullable<number>> = ref(null)

const computedImages = computed(() =>
  props.images.map((item) => {
    if ('src' in item) {
      return getDynamicImage({
        path: item.path,
        preset: presets.NATIVE_LG,
        isStatic: item.isStatic,
      }) ?? item.src
    }
    return {
      component: AppVideoPlayer,
      props: { video: item, noWrapper: true, autoplay: false },
    }
  }),
)

const computedThumbnails = computed(() =>
  props.images.map((item) => ('src' in item ? item.src : item.thumbnail)),
)

function showLightBox(index: number) {
  slide.value = index + 1
  toggler.value = !toggler.value
}

function openSlide(instance: number) {
  setTimeout(() => {
    emit('track-image', instance)
  })
}

function changeSlide(instance: number) {
  emit('track-image', instance)
}
</script>
